module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image2.ef8ed139.webp";